import { useQuery } from '@tanstack/react-query';

import { getSessionVerdict } from '../services/api/judge';

export const useJudgeVerdict = (sessionId: string) =>
  useQuery({
    queryKey: ['judge-verdict', sessionId],
    queryFn: () => getSessionVerdict(sessionId),
    retry: false,
  });
